import { UseAdyenApplePay } from './hooks/use-adyen-apple-pay';
import { AdyenComponentContainer } from '../../../AdyenPaymentElement/components/AdyenComponentContainer/AdyenComponentContainer';

import './styles.scss';

interface AdyenApplePayProps {
  onReady: (isAvailable: boolean) => void;
}

export function AdyenApplePay({ onReady }: AdyenApplePayProps) {
  const { applePay } = UseAdyenApplePay(onReady);

  if (!applePay) return null;

  return <AdyenComponentContainer element={applePay} hideLoader />;
}
